import { useCallback } from 'react'
import { useAtom, useSetAtom } from 'jotai'

import { getUpdatedSearchUrl } from '../helpers'
import {
    searchSubmissionAtom,
    suggestedStartTimeShiftAtom,
} from '../state'
import type { LaterAvailabilityTime } from '../types'

let nextShiftId = 0

export const useApplySuggestedStartTime = ({
    urlVariant,
    garageId,
}: {
    urlVariant?: 'map' | 'reservation',
    garageId?: string,
} = {}) => {
    const [searchSubmission, setSearchSubmission] = useAtom(searchSubmissionAtom)
    const setSuggestedStartTimeShift = useSetAtom(suggestedStartTimeShiftAtom)

    return useCallback((startTime: LaterAvailabilityTime) => {
        const updatedSearch = {
            ...searchSubmission,
            startTime,
        }

        setSearchSubmission(updatedSearch)

        setSuggestedStartTimeShift({
            id: ++nextShiftId,
            previousSearch: searchSubmission,
            appliedSearch: updatedSearch,
            startTime,
            urlVariant,
            garageId,
        })

        if (urlVariant && !window.location.pathname.startsWith('/pwa')) {
            window.history.replaceState(
                {},
                '',
                getUpdatedSearchUrl({
                    currentUrl: window.location.href,
                    searchSubmission: updatedSearch,
                    variant: urlVariant,
                    garageId,
                }),
            )
        }
    }, [
        garageId,
        searchSubmission,
        setSearchSubmission,
        setSuggestedStartTimeShift,
        urlVariant,
    ])
}
